import React, { useEffect } from 'react';
type PixelCommand = (...args: unknown[]) => void;
type PixelFunction = PixelCommand & {
  callMethod?: PixelCommand;
  queue?: unknown[][];
  push?: PixelCommand;
  loaded?: boolean;
  version?: string;
};
type MetaPixelWindow = Window & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
  __metaPixelInitialized?: boolean;
  __metaPixelPageViewSent?: boolean;
};
type Props = {
  pixelId: string;
};
export function MetaPixel({
  pixelId
}: Props) {
  useEffect(() => {
    const metaWindow = window as MetaPixelWindow;
    if (!metaWindow.fbq) {
      const queue: unknown[][] = [];
      const fbq = ((...args: unknown[]) => {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
          return;
        }
        queue.push(args);
      }) as PixelFunction;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = queue;
      metaWindow.fbq = fbq;
      metaWindow._fbq = fbq;
      const script = document.createElement('script');
      script.id = 'meta-pixel-script';
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    if (!metaWindow.__metaPixelInitialized) {
      metaWindow.fbq?.('init', pixelId);
      metaWindow.__metaPixelInitialized = true;
    }
    if (!metaWindow.__metaPixelPageViewSent) {
      metaWindow.fbq?.('track', 'PageView');
      metaWindow.__metaPixelPageViewSent = true;
    }
  }, [pixelId]);
  return null;
}